import type {Pointer} from '@wix/document-services-types'
import {createHookDefinition} from '../../utils/hooksUtils'
import type {FeatureData} from './features'

interface FeatureDataUpdate {
    compPointer: Pointer
    featureName: string
    featureData: FeatureData
}

export const FEATURE_DATA_HOOKS = {
    UPDATE: {
        AFTER: createHookDefinition<'after_feature_data_update', FeatureDataUpdate>('after_feature_data_update')
    }
}
